import config from "temp/config";

const endpoint = "/api/sitecore/formlogging";

export function saveMessageLogs(logList, formData) {
  const fetchData = {
    messages: logList,
    formData: formData,
  };
  console.log("-----saveMessageLogs------", fetchData);
  if (!logList || logList.length < 1) return false;
  const baseUrl = config.sitecoreApiHost + `${endpoint}/Update`;

  return fetch(baseUrl, {
    method: "POST",
    body: JSON.stringify(fetchData),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
}
